import './logo.scss';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

interface LogoProps {
  className?: any;
}

const Logo = (props: LogoProps) => {
  return (
    <Link className={classNames('logo', props.className)} to="/">
      <img
        src="https://d1bl2vonzwz2m2.cloudfront.net/assets/logos/logo-ashtrom-host.png"
        className='logo'
        alt="logo"
      />
    </Link>
  );
};
export default Logo;
